import { Client } from "../../clients/client";
import { PaginationForm, Pagination } from "@/common/mixins/pagination";
import { ShipnityCreateForm } from "./forms/ShipnityCreateForm";
import { ShipnityUpdateForm } from "./forms/ShipnityUpdateForm";
import { Shipnity } from "./models/Shipnity";

export class ShipnityUseCase {
  constructor(private client: Client) {}

  async createShopShipnity(form: ShipnityCreateForm) {
    return this.client.shipnity.postShipnity({
      ...form,
      shopId: form.shop?.id!,
      stockIdValue: form.stockIdValue ? +form.stockIdValue : null
    });
  }

  async updateShopShipnity(id: number, form: ShipnityUpdateForm) {
    return this.client.shipnity.patchShipnity(id, {
      ...form,
      stockIdValue: form.stockIdValue ? +form.stockIdValue : null
    });
  }

  async getShipnity(form: PaginationForm): Promise<Pagination<Shipnity>> {
    return this.client.shipnity.getShipnity({
      page: form && form.page,
      limit: form && form.perPage
    });
  }

  async getShipnityById(id: number) {
    return this.client.shipnity.getShipnityById(id);
  }

  async deleteShipnity(id: number) {
    return this.client.shipnity.deleteShipnity(id);
  }

  async syncProductByShopId(id: number) {
    return this.client.shipnity.postShipnityProductSyncByShopId(id);
  }

  async syncStockByShopId(id: number) {
    return this.client.shipnity.postShipnityStockSyncByShopId(id);
  }
}
